import clsx from 'clsx';
import type { FieldValues, Path, UseFormSetValue } from 'react-hook-form';

// import type { ChangeEventHandler } from 'react';
// import { DownloadIcon } from '@/assets/react-icons/DownloadIcon';
import { TrashIcon } from '@/assets/react-icons/TrashIcon';
import { UploadIcon } from '@/assets/react-icons/UploadIcon';
import { Button } from '@/components/Button';
import { Loader } from '@/components/Loader';
import { Text } from '@/components/Text';

import styles from './LandDocumentUploader.module.scss';

type Props<T extends FieldValues = FieldValues> = {
  className?: string;
  description?: string;
  error?: string;
  hasUploadedFiles: boolean;
  isEditBlockMode: boolean;
  isLoading?: boolean;
  multiple?: boolean;
  name: Path<T>;
  onChange: (files: (File | string)[]) => void;
  onDelete?: (fileName: string) => void;
  setValue: UseFormSetValue<T>;
  title: string;
  value: (File | string)[];
};

export const LandDocumentUploader = <T extends FieldValues>({
  className,
  description,
  error,
  // hasUploadedFiles,
  isEditBlockMode,
  isLoading,
  multiple = true,
  name,
  onChange,
  onDelete,
  // setValue,
  title,
  value,
}: Props<T>) => {
  return (
    <div className={clsx(styles.wrapper, className)}>
      <div className={clsx(styles['land-download'], !isEditBlockMode && styles.isSaved)}>
        <Text type='p2'>{title}</Text>
        <label
          className={clsx(
            styles.label,
            !multiple && value.length > 0 && styles.disabled,
            value.length > 4 && styles.disabled,
          )}
          htmlFor={name}
        >
          {isLoading && <Loader />}
          <Button
            asDiv
            blue
            disabled={(!multiple && value.length > 0) || isLoading || value.length > 4}
            icon={<UploadIcon />}
            small
          >
            Завантажити
          </Button>
        </label>
        <input
          accept='.xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf'
          id={name}
          name={name}
          onChange={(e) => {
            const files = Array.from(e.target.files ?? []);

            onChange(multiple ? files : [files[0]]);
          }}
          onClick={(e) => void (e.currentTarget.value = '')}
          type='file'
        />
      </div>

      {value && value.length > 0 && (
        <div className={styles.documentsList}>
          {value.map((pathOrFile, fileIndex) => {
            const filename =
              typeof pathOrFile === 'string' ? pathOrFile.split('/').at(-1) : pathOrFile.name;

            const deleteFile = () => {
              // const file = multiple ? value.filter((_, index) => index !== fileIndex) : [];

              // onChange(file);
              // setValue(name, file as any);

              onDelete?.(pathOrFile as string);
            };

            // const downloadFile = () => {
            //   const a = document.createElement('a');

            //   a.href =
            //     typeof pathOrFile === 'string' ? pathOrFile : URL.createObjectURL(pathOrFile);

            //   a.download = filename ?? 'unknown';

            //   document.body.appendChild(a);

            //   a.click();

            //   URL.revokeObjectURL(a.href);

            //   document.body.removeChild(a);
            // };

            return (
              <div className={styles['document']} key={fileIndex}>
                <Text type='p3'>{filename}</Text>
                <div className={styles.documentButtons}>
                  {/* {hasUploadedFiles ? (
                    <a
                      className={styles.documentButtons__download}
                      // download

                      href={`https://dobrozem-api-xbajg7eaphkl.quadroom.agency${pathOrFile as string}`}
                    >
                      <DownloadIcon />
                    </a>
                  ) : (
                    <button
                      className={styles.documentButtons__download}
                      onClick={downloadFile}
                      type='button'
                    >
                      <DownloadIcon />
                    </button>
                  )} */}
                  <button
                    className={styles.documentButtons__delete}
                    onClick={deleteFile}
                    type='button'
                  >
                    <TrashIcon />
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
      {description && (
        <Text className={styles['land-documents-description']} color='basic-green' type='p4'>
          {description}
        </Text>
      )}
      {error && (
        <Text color='red' type='p6'>
          {error}
        </Text>
      )}
    </div>
  );
};
